import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CoreTable from "../../coreComponents/Table/Table.tsx";
import { deleteTestNumber, getAllTestNumbers } from "../../services/CommonService.ts";
import Button from "../../coreComponents/Button/Button.tsx";
import { TestUser } from "./types.ts";
import { Snackbar, Alert } from '@mui/material';



const columns = [
  { id: "id", label: "ID" },
  { id: "hardcoded_otp", label: "OTP" },
  { id: "phone_number", label: "Phone No" }
];

const CreateTestNumber: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<TestUser[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: 'success' | 'error' }>({
    open: false,
    message: '',
    severity: 'success'
  });

  useEffect(() => {
    const fetchTestNumbersData = async () => {
      try {
        const response = await getAllTestNumbers();
        if (response.data) {
          console.log(response.data);
          setData(response.data);
        }
      } catch (err: any) {
        if (err.response && err.response.status === 401) {
          console.error("Unauthorized access. Redirecting to login...");
          navigate("/login");
        } else {
          setError("Failed to fetch test numbers");
          console.log(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTestNumbersData();
  }, []);


  const handleUpdate = (id: number) => {
    console.log(`Update User with ID: ${id}`);
  };

  const handleDelete = async (id: number) => {
    try {
      const response = await deleteTestNumber(id.toString());
      if (response.error === null) {
        setSnackbar({
          open: true,
          message: 'Test number deleted successfully',
          severity: 'success'
        });
        // Refresh the data after successful deletion
        setData(data.filter(item => item.id !== id));
      } else {
        setSnackbar({
          open: true,
          message: response.errorDetails || 'Failed to delete test number',
          severity: 'error'
        });
      }
    } catch (err: any) {
      setSnackbar({
        open: true,
        message: 'Failed to delete test number',
        severity: 'error'
      });
      console.log(err);
    }
  };

  const handleCreateTestNumber = () => {
    navigate("/create-test-number");
  }

  if (loading && data.length === 0) return <div>Loading test numbers...</div>;

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      <CoreTable
        columns={columns}
        data={data}
        label2="Delete Test Number"
        // onUpdate={handleUpdate}
        onDelete={handleDelete}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreateTestNumber;
